import React from 'react';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom

function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer style={{
            backgroundColor: 'black', // Light gray background
            padding: '20px',
            textAlign: 'center',
            borderTop: '1px solid #ccc',
            marginTop: 'auto', // Push to the bottom (if using flexbox on the main content)

        }}>
            <div>
                <Link to="/tos" style={{ margin: '0 10px', textDecoration: 'none', color: '#333' }}>Terms of Service</Link>
                <Link to="/privacy" style={{ margin: '0 10px', textDecoration: 'none', color: '#333' }}>Privacy Policy</Link>
                <Link to="/contact" style={{ margin: '0 10px', textDecoration: 'none', color: '#333' }}>Contact Us</Link>
            </div>
            <p style={{ marginTop: '10px', color: '#666', fontSize: '0.9em' }}>
                &copy; {currentYear} OldMoldyCake. All rights reserved.
            </p>
        </footer>
    );
}

export default Footer;